module.exports = __webpack_public_path__ + "static/media/team-icon.7d9ca785.svg";